import { GET_ZUSCHLAGSGRUPPEN_BY_STANDORT } from '@/domain/mitarbeiter/features/anlageassistent/hooks/useZuschlagsgruppen/graphql/queries';
import {
  Mitarbeiter_GetZuschlagsgruppenQuery,
  Mitarbeiter_GetZuschlagsgruppenQueryVariables,
} from '@/gql/graphql';
import { useSuspenseQuery } from '@apollo/client/react';
import * as Sentry from '@sentry/react';

export function useZuschlagsgruppen(standortId: string): {
  zuschlagsgruppen: Array<{ id: string; name: string }>;
} {
  const result = useSuspenseQuery<
    Mitarbeiter_GetZuschlagsgruppenQuery,
    Mitarbeiter_GetZuschlagsgruppenQueryVariables
  >(GET_ZUSCHLAGSGRUPPEN_BY_STANDORT, { variables: { standortId } });

  if (
    result.error ||
    result.data.zuschlagsgruppenByIdStandorte.__typename ===
      'ZuschlagsgruppeError'
  ) {
    if (result.error) {
      Sentry.captureException(result.error);
    } else if (
      result.data.zuschlagsgruppenByIdStandorte.__typename ===
      'ZuschlagsgruppeError'
    ) {
      Sentry.captureException(
        result.data.zuschlagsgruppenByIdStandorte.message,
      );
    }
    return {
      zuschlagsgruppen: [],
    };
  }

  return {
    zuschlagsgruppen:
      result.data.zuschlagsgruppenByIdStandorte.zuschlagsgruppen.map(
        (zuschlagsgruppe) => ({
          id: zuschlagsgruppe.id,
          name: zuschlagsgruppe.name,
        }),
      ),
  };
}
